export default "__VITE_ASSET__C$5muQkT__"